<template>
  <input
    ref="rangepick"
    class="form-control"
    type="text"
    :placeholder="$t('src/plugins/daterangeinput.7335')"
  />
</template>

<script>
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import { English } from 'flatpickr/dist/l10n/default.js'

export default {
  name: 'RangeCalendar',
  props: {
    startDate: {
      type: Date,
      required: false
    },
    endDate: {
      type: Date,
      required: false
    },
    minDate: {
      type: String
    },
    maxDate: {
      type: String
    },
    disable: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    calendar: null
  }),
  watch: {
    startDate() {
      if (this.startDate == null) {
        this.clearValue()
      } else {
        this.calendar.set('defaultDate', this.startDate)
      }
    },
    endDate() {
      this.calendar.set('defaultDate', this.endDate)
    },
    minDate: 'updateCalendar',
    maxDate: 'updateCalendar',
    disable: 'updateCalendar',
    localeRU() {
      // При изменении локали пересоздаем календарь
      this.reinitCalendar()
    }
  },
  mounted() {
    this.initCalendar()
  },
  beforeDestroy() {
    if (this.calendar) {
      this.calendar.destroy()
    }
  },
  computed: {
    localeRU() {
      return this.$i18n.locale === 'ru'
    }
  },
  methods: {
    initCalendar() {
      if (!this.$refs.rangepick) {
        return
      }

      const format = this.localeRU ? 'd.m.Y' : 'm/d/Y'
      flatpickr.localize(this.localeRU ? Russian : English)
      this.calendar = flatpickr(this.$refs.rangepick, {
        mode: 'range',
        dateFormat: format,
        defaultDate: this.startDate && this.endDate ? [this.startDate, this.endDate] : null,
        minDate: this.minDate ? this.minDate : null,
        maxDate: this.maxDate ? this.maxDate : null,
        disable: this.disable,
        onChange: date => {
          if (date.length === 2) {
            this.$emit('input', date[0], date[1])
          }
        }
      })
    },
    reinitCalendar() {
      this.destroyCalendar()
      this.initCalendar()
    },
    destroyCalendar() {
      if (this.calendar) {
        this.calendar.destroy()
        this.calendar = null
      }
    },
    updateCalendar() {
      if (!this.calendar) {
        return
      }
      if (this.minDate) {
        this.calendar.set('minDate', this.minDate)
      }
      if (this.maxDate) {
        this.calendar.set('maxDate', this.maxDate)
      }
      if (this.disable) {
        this.calendar.set('disable', this.disable)
      }
    },
    openPicker() {
      if (this.calendar) {
        this.calendar.open()
      }
    },
    clearValue() {
      if (this.calendar) {
        this.calendar.clear()
      }
    }
  }
}
</script>
